import React from 'react';
import { Box, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getControlTokens } from './controlTokens';

function ControlNumberInput({
  context = 'filterBar',
  value,
  onChange,
  onFocus,
  onKeyDown,
  label = 'n',
  min = 0,
  step = 1,
  defaultValue = 0,
  maxDigits = 4,
  textFieldProps,
}) {
  const theme = useTheme();
  const tokens = getControlTokens(theme, context);
  const digitWidth = context === 'objectToolbar' ? 5.8 : 6.4;
  const horizontalPadding = context === 'objectToolbar' ? 8 : 10;
  const inputWidth = Math.ceil(maxDigits * digitWidth + horizontalPadding);
  const labelWidth = Math.max(context === 'objectToolbar' ? 17 : 18, String(label).length * 6 + 12);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        gap: 0.25,
        width: 'max-content',
        minWidth: 0,
        height: tokens.height,
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          fontSize: tokens.labelFontSize,
          lineHeight: 1,
          color: tokens.textColor,
          width: labelWidth,
          flexShrink: 0,
          whiteSpace: 'nowrap',
          textAlign: 'center',
        }}
      >
        {label} ≥
      </Box>
      <TextField
        size="small"
        type="number"
        variant="outlined"
        data-control-inline-form="true"
        value={value ?? defaultValue}
        onChange={onChange}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        inputProps={{
          min,
          step,
          inputMode: 'numeric',
          pattern: '[0-9]*',
          'aria-label': `${label} minimum`,
        }}
        sx={{
          flex: '0 0 auto',
          minWidth: 0,
          width: inputWidth,
          '& .MuiOutlinedInput-root': {
            height: tokens.height,
            width: '100%',
            minWidth: 0,
            backgroundColor: tokens.surface,
          },
          '& .MuiOutlinedInput-input': {
            padding: context === 'objectToolbar' ? '3px 4px' : '6px 5px',
            minWidth: 0,
            fontSize: tokens.fontSize,
            lineHeight: 1.2,
            color: theme.palette.text.secondary,
            textAlign: 'right',
            MozAppearance: 'textfield',
          },
          '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
        }}
        {...textFieldProps}
      />
    </Box>
  );
}

export default ControlNumberInput;
